module.exports = __webpack_public_path__ + "img/yellow2.2351653f.svg";